<template>
	<div style="background:white;padding:5px;margin-bottom:5px;border-radius: 5px;position:relative;" :title="this.title"
		class="flexcenter link" @click="this.$emit('searchManufactorSelected', this.manufactor)">
		<div v-if="!this.productTypeSelected" style="position:absolute;top:5px;right:5px;background:var(--grey-3);padding:3px;border-radius:5px;"><b
				style="color:grey;font-size:80%;">{{ this.productTypeLabel }}</b></div>
		<img :src="this.src" style="object-fit: contain;width:100%;height:100%;" />


	</div>
</template>
<script>
import { STORE_GETTER } from '@/store/store';
import { routerMixin } from "@/mixins/routerMixin.js";
import settings from '../../../settings';

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchManufactorCell",
	components: {},
	mixins: [routerMixin],
	props:{
		manufactorId: Number,
		productCount: String
	},
	data() {
		return {

		};
	},
	computed: {

		title(){
			if (this.isOnProductListPage()) {
				return "Filtera resultatet på " + this.manufactor?.name;
			}else{
				return "Visa alla produkter från: " + this.manufactor?.name + ", antal: " + this.productCount
			}
			
		},

		manufactor() {
			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			return manufactorList?.find(manufactor => manufactor.manufactorId == this.manufactorId)

		},


		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]
		},

		productTypeSelected() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},

		productTypeLabel() {
			const productType = this.productTypeModel?.list?.find(productType => productType.pt == this.manufactor.pt )
			if (productType){
				return productType.name
			}
			return null;
		},

		src(){
			//return "https://public.boove.se/gfx/logos/" + this.manufactor.manufactorId + ".jpg"
			return settings.manufactorLogoPath + this.manufactor.manufactorId + ".jpg"
		}

	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped></style>